import AppContext from 'App/AppContext';
import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { takeSignInReturnPath } from 'services/Auth/signInReturnPath';

//
// Opens the page a signed-out user asked for (SignInRedirect) once the sign-in completes, whichever provider signed
// them in. Only from the root, where every sign-in started; a sign-in that came back elsewhere drops the kept page.
// The target route checks the user's access itself.
//
export const useSignInReturn = (): void => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isSignedIn = appContext.isAuthenticated && !appContext.isAuthInProgress;

  useEffect(() => {
    if (!isSignedIn) return;

    const returnPath = takeSignInReturnPath();
    if (returnPath && pathname === '/') navigate(returnPath, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSignedIn]);
};
